import { Injectable, inject } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {TranslateService} from "@ngx-translate/core";
import {SharedSolutionActions} from "@shared/components/solution/store/shared-solution.actions-type";
import {SharedSolutionApiService} from "@shared/components/solution/services/shared-solution-api.service";
import {exhaustMap, withLatestFrom} from "rxjs";
import {SharedSolutionSelectors} from "@shared/components/solution/store/shared-solution.selector-type";
import {catchError, map} from "rxjs/operators";
import {ILocalPagination} from "@shared/interfaces/pagination.interface";
import {SharedLoginSelectors} from "@shared/components/login/store/shared-login.selector-type";
import {SolutionItemDto} from "@server-models";
import {TechMissionCreateActions} from "@tech/pages/inventory/pages/mission-create/store/tech-mission-create.actions-type";
import {TechInventoryApiService} from "@tech/pages/inventory/services/tech-inventory-api.service";
import {TechInventoryActions} from "@tech/pages/inventory/store/tech-inventory.actions-type";
import {TechMissionCreateSelectors} from "@tech/pages/inventory/pages/mission-create/store/tech-mission-create.selector-type";

@Injectable({
  providedIn: 'root',
})
export class TechMissionCreateEffects {
  private _store = inject(Store);
  private _actions$ = inject(Actions);
  private _inventoryApiService = inject(TechInventoryApiService);


  getMission$ = createEffect(() =>
    this._actions$.pipe(
      ofType(TechMissionCreateActions.getMission),
      exhaustMap(({ missionId }) => {
        return this._inventoryApiService.getMissionDetailById(missionId.toString()).pipe(
          map(model => TechMissionCreateActions.getMissionSuccess({ model })),
          catchError((error) => [
            TechMissionCreateActions.getMissionFail({ error }),
          ])
        )
      })
    )
  );

  postMission$ = createEffect(() =>
    this._actions$.pipe(
      ofType(TechMissionCreateActions.postMission),
      withLatestFrom(
        this._store.select(SharedLoginSelectors.selectTenant).pipe(map(t => t?.tenantId ?? 0))
      ),
      exhaustMap(([{ model }, tenantId]) => {

        // Pass tenant id
        model.tenantId = tenantId;

        return this._inventoryApiService.postMission(model).pipe(
          exhaustMap((newMission) => [
            TechMissionCreateActions.postMissionSuccess({ model: newMission })
          ]),
          catchError((error) => [
            TechMissionCreateActions.postMissionFail({ error }),
          ])
        )
      })
    )
  );

  postFollowUpMission$ = createEffect(() =>
    this._actions$.pipe(
      ofType(TechMissionCreateActions.postFollowUpMission),
      withLatestFrom(
        this._store.select(SharedLoginSelectors.selectTenant).pipe(map(t => t?.tenantId ?? 0))
      ),
      exhaustMap(([{ missionId, model }, tenantId]) => {

        // Pass tenant id
        model.tenantId = tenantId;

        return this._inventoryApiService.postFollowUpMission(missionId, model).pipe(
          exhaustMap((newMission) => [
            TechMissionCreateActions.postFollowUpMissionSuccess({ model: newMission })
          ]),
          catchError((error) => [
            TechMissionCreateActions.postFollowUpMissionFail({ error }),
          ])
        )
      })
    )
  );
}
